import React from 'react';
import './TableHeader.less';
export default function (props) {
    var column = props.column;
    return (React.createElement("div", { className: "table_header", style: { minWidth: column.width ? column.width : null } },
        React.createElement("span", { className: "title" }, column.title)));
}
